import { useState } from "react";
import FocusLock from "react-focus-lock";
import { LockIcon } from "@/shared/icons";
import { Button, TextInput } from "@/shared/ui";

type Props = {
  password: string;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onForgetPassword: () => void;
  error?: string;
  pending: boolean;
};

function AuthSignIn({
  password,
  onPasswordChange,
  onForgetPassword,
  onSubmit,
  error = "",
  pending,
}: Props) {
  const [validate, setValidate] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={(e) => {
          setValidate(true);
          e.preventDefault();
          if (!password) return;
          onSubmit(e);
        }}
        className="gap-3 grow flex flex-col"
      >
        <TextInput
          type="password"
          placeholder="Введите пароль"
          title="Пароль:"
          icon={<LockIcon size={16} />}
          invalid={validate && !password ? "Введите пароль" : ""}
          value={password}
          onChange={onPasswordChange}
          required
          className="text-center"
          passwordVisible={isPasswordVisible}
          onChangePasswordVisible={setIsPasswordVisible}
        />
        <button
          type="button"
          className="text-center underline decoration-1 underline-offset-2 hover:text-white/75 transition ml-auto"
          onClick={onForgetPassword}
        >
          Забыли пароль?
        </button>
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button className="btn--md w-full" submit loading={pending}>
            Войти в игру
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}

export default AuthSignIn;
